import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgTasks = function SvgTasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 3v7h16v48H11V10h16V3h7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 3v7h16v48H11V10h16V3h7z",
    fill: "#FFF",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.375 7.5H36.992c.047-.305.07-.621.07-.938A6.567 6.567 0 0030.5 0a6.567 6.567 0 00-6.563 6.563c0 .316.024.632.07.937H13.626A5.626 5.626 0 008 13.125v41.25A5.626 5.626 0 0013.625 60h33.75A5.626 5.626 0 0053 54.375v-41.25A5.626 5.626 0 0047.375 7.5zM30.5 3.75a2.806 2.806 0 012.813 2.813A2.806 2.806 0 0130.5 9.374a2.806 2.806 0 01-2.813-2.813A2.806 2.806 0 0130.5 3.75zm18.75 50.625a1.88 1.88 0 01-1.875 1.875h-33.75a1.88 1.88 0 01-1.875-1.875v-41.25a1.88 1.88 0 011.875-1.875h5.625v2.344A1.41 1.41 0 0020.656 15h19.688a1.41 1.41 0 001.406-1.406V11.25h5.625a1.88 1.88 0 011.875 1.875v41.25zm-6.902-27.703a1.418 1.418 0 00-1.993-.012L26.563 40.348l-5.907-5.93a1.408 1.408 0 00-1.992 0l-.996.996c-.55.55-.55 1.441 0 1.992l7.898 7.922c.551.55 1.442.55 1.993 0L43.355 29.66c.551-.55.551-1.441.012-1.992l-1.02-.996z",
    fill: "currentColor"
  })));
};
export default SvgTasks;